import React from 'react'
import { Shield } from 'lucide-react'
import { useNavigate } from 'react-router-dom'

const GuaranteeSection = () => {
  const navigate = useNavigate()

  const handleStartTrial = () => {
    navigate('/signup')
  }

  return (
    <section className="section-padding">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
        <div className="bg-blue-50 rounded-lg p-12 group hover:bg-blue-100 transition-colors duration-200">
          <div className="w-20 h-20 bg-blue-600 rounded-full flex items-center justify-center mx-auto mb-6 group-hover:scale-110 transition-transform duration-200">
            <Shield className="w-10 h-10 text-white" />
          </div>
          <h2 className="text-3xl font-bold text-gray-900 mb-6">
            Try it risk-free.
          </h2>
          <p className="text-lg text-gray-600 mb-8 leading-relaxed">
            We know you'll find insights that pay for themselves. But if you don't see actionable value 
            within 30 days, we'll refund your money and cover return shipping — no questions asked.
          </p>
          <div className="inline-flex items-center gap-2 bg-green-100 text-green-800 px-6 py-3 rounded-full font-semibold mb-8">
            <Shield className="w-5 h-5" />
            30-Day Money-Back Guarantee
          </div>
          <div>
            <button 
              onClick={handleStartTrial}
              className="btn-primary"
            >
              Start Your Trial
            </button>
          </div>
        </div>
      </div>
    </section>
  )
}

export default GuaranteeSection